import gql from 'graphql-tag';

export default gql`
  subscription OnVPStatusChange($vpId: ID) {
    onVPStatusChange(vpId: $vpId) {
      vpId
      status
      meetingId
      meetingName
      userId
      message
      updatedAt
    }
  }
`;
